<div class="multi-select-container" [ngClass]="{'has-errors': hasErrors}">
  <boi-validation-error-generic (errorChange)="onErrorChange($event)" [validationErrors]="validationErrors"
    [propertyNames]="validationPropertyNames">
  </boi-validation-error-generic>
  <kendo-textbox-container>
    <div [ngClass]="cssClasses" class="field-container">
      <div class="field-label" [boiRequiredFormField]="required ? labelName : undefined"
        [forceRequired]="forceRequired">
        <ng-container *ngIf="labelName">
          <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName | localizeLabel"></label>
        </ng-container>
      </div>
      <div class="field-input">
        <kendo-multiselect [popupSettings]="popupSettings" [placeholder]="placeholder"
          [data]="optionList ? (optionList | localizeOptionList) : availableOptions" [valuePrimitive]="valuePrimitive"
          [textField]="textField" [id]="controlId ? controlId : labelName" [valueField]="valueField" [(ngModel)]="value"
          [disabled]="isFieldDisabled" [kendoDropDownFilter]="filterSettings" [filterable]="filterable"
          (filterChange)="filterChange.emit($event)">
          <ng-template kendoMultiSelectItemTemplate let-item>
            <span [innerHtml]="getItemDisplayKeys(item)"></span>
          </ng-template>
          <ng-template kendoMultiSelectTagTemplate let-item>
            <span [innerHtml]="getItemTagKeys(item)"></span>
          </ng-template>
        </kendo-multiselect>
      </div>
    </div>
    <ng-container *ngIf="showTooltip">
      <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
    </ng-container>

  </kendo-textbox-container>
</div>
